import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OfertasListComponent } from './ofertas-list/ofertas-list.component';


const routes: Routes = [

    { path: '', component: OfertasListComponent  },
    { path: 'edit/:id', component: OfertasListComponent },
    { path: 'crear', component: OfertasListComponent }, 
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppOfertasRoutingModule {}
